import { Component, Input, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PartnerQueryStatus } from 'src/app/core/models/PartnerQueryStatus';
import { QueryModel } from 'src/app/core/models/QueryModel';
import { QueryStatus } from 'src/app/core/models/QueryStatus';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { AdminService } from '../../admin/admin.service';
import { BreadcrumbService } from 'src/app/core/services/breadcrumb.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ViewAttachmentsComponent } from '../view-attachments/view-attachments.component';
import { openViewAttachmentsModal } from '../Shared/CommonHelper';

@Component({
  selector: 'partner-view-query',
  standalone: false,
  templateUrl: './partner-view-query.component.html',
  styleUrl: './partner-view-query.component.less'
})
export class PartnerViewQueryComponent {
  @Input() queryModel!: QueryModel;
  queryCode: number = 0;

  currentUser: User = new User();
  queryStatus: QueryStatus = QueryStatus.New;
  dropdownSettings = {};
  partnerUserMaster: { value: any; label: any }[] = [];
  selectedCCUsers: [] = [];

  canViewDeletedComment = false;
  canViewResponseDetails = false;
  partnerQueryStatus: PartnerQueryStatus = PartnerQueryStatus.New;

  partnerUploadedAttachmtCnt = 0;
  internalUserUploadedAttachmtCnt = 0;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private adminService: AdminService,
    private userService: UserService,
    private breadcrumbService: BreadcrumbService,
    private modalService: NzModalService,
  ) {
    const queryCodeParam = this.route.snapshot.paramMap.get('queryCode');
    this.queryCode = queryCodeParam ? +queryCodeParam : 0;
    this.setBreadcrumb();
  }
  setBreadcrumb() {
    this.breadcrumbService.setBreadcrumbs([
      { label: 'Home', url: '/' },
      { label: 'Clarification Query', url: '/clarification-query' },
      { label: 'View Query' }
    ]);
  }

  ngOnInit() {
    this.currentUser = this.userService.getCurrentUser();
    this.initialiseData();
    if (this.currentUser?.User_Code == null) {
      this.router.navigate(['/']);
    }
    else {
      this.partnerUploadedAttachmtCnt = this.queryModel.QueryDetail.FileAttachments.filter(s => s.Partner_UploadedFile).length;
      this.internalUserUploadedAttachmtCnt = this.queryModel.QueryDetail.FileAttachments.filter(s => !s.Partner_UploadedFile).length;
      if (this.queryModel.PartnerQueryStatusEnum == PartnerQueryStatus.Responded) {
        this.canViewResponseDetails = true;
      }
      else if (this.queryModel.PartnerQueryStatusEnum == PartnerQueryStatus.DeletedByPartner
        || this.queryModel.PartnerQueryStatusEnum == PartnerQueryStatus.DeletedByRFCAdmin) {
        this.canViewResponseDetails = true;
        this.canViewDeletedComment = true;
      }
      if (this.queryModel.QueryDetail.CCUsers?.length) {
        this.adminService.getAllRegisteredPartners().subscribe({
          next: (response: any) => {
            if (response.output.length > 0) {
              for (var i = 0; i < response.output.length; i++) {
                this.partnerUserMaster.push({ value: response.output[i].User_Code, label: response.output[i].User_Name });
              }              
              this.selectedCCUsers = [];
              if (this.queryModel.QueryDetail.CCUsers) {
                this.selectedCCUsers = this.queryModel.QueryDetail.CCUsers;                
              }
            }

          },
          error: () => {
            this.router.navigate(['/clarification-query/my-query']);
          }
        });
      }
    }
  }
  viewAttachments(viewPartnerUploadedFiles: boolean) {
    this.queryModel.QueryDetail.Query_Reference_Number = this.queryModel.Query_Reference_Number;
    openViewAttachmentsModal(this.modalService, this.queryModel.QueryDetail, viewPartnerUploadedFiles);    
  }
  initialiseData() {
    this.partnerUserMaster = [];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
    };
  }

}
